var $ = require('jquery');
var page = require('diy/page/page');

/*global window, document, diy*/
(function () {
    'use strict';

    var rootScope = this;

    /* ui blocking functions */
    this.uiBlocker = function() {
        return {
            block: function () {
                for (var x in mm) {
                    mm[x].overlayFrozen = true;
                    $('#modul_'+x).append('<span class="ui-blocker-blockme"></span>');
                }

                $('#diywebHeader').append('<span class="ui-blocker-blockme"></span>');
                $('#cc-sa').append('<span class="ui-blocker-blockme"></span>');

                $('span.ui-blocker-blockme').each(function() {
                    var parent = $(this).parent();
                    parent.css('position','relative');

                    $(this).css({
                        'position':'absolute', 'top':'0px', 'left':'0px','display':'block',
                        'background-color':'#ffffff', 'opacity':'0.7','z-index':200000
                    });

                    $(this).width(parent.width());
                    $(this).height(parent.height());
                });
            },
            unblock: function () {
                for (var x in mm) {
                    mm[x].overlayFrozen = false;
                    $('.ui-blocker-blockme').remove();
                }
            }
        }
    };

    /* the dialog with import / remove functionality */
    this.referenceDialog = function() {
        return {
            pageId:null,
            useCaseId:null,
            dialogElement:null,
            init:function(useCaseId) {
                this.pageId = page.getCurrentPageId();
                this.useCaseId = useCaseId;
                var template = this.generateTemplate();
                this.dialogElement = $(template).appendTo($('body'));
                this.blocker = rootScope.uiBlocker();
                this.initDialog();
            },
            /**
             * just open the dialog
             */
            open: function() {
                this.dialogElement.dialog.open();
            },
            /**
             * close the dialog
             */
            close: function() {
                this.dialogElement.dialog.close();
            },
            /**
             * call the diy_dialog and initialize blocker onload
             */
            initDialog:function() {
                var self = this;
                this.dialogElement.diy_dialog({
                    dialogClass: 'use-case-edit-session-additional-dialog',
                    width: 300,
                    height: 240,
                    draggable: true,
                    closeButton: false,
                    position: {
                        at: 'center'
                    },
                    zIndex: 200000000,
                    open: function () {
                        setTimeout(self.blocker.block, 1337);
                    },
                    close: function () {
                    },
                    closeOnEscape: false,
                    title: 'Referenced Content'
                });
            },
            /**
             * create <a href="">element with actions triggering xmlhttp request
             *
             * @param text {string}
             * @param action {string}
             * @returns {jQuery|HTMLElement}
             */
            createLink : function (text, action) {
                var link = $('<a />');
                link.attr('href', '/app/usecase/usecase/' + action + '/?' + $.param({ pageId: this.pageId }));
                link.text(text);
                link.click(function (event) {
                    event.preventDefault();
                    $.get(this.href, function(response) {
                        if (typeof(response) != 'object') {
                            $('#use-case-edit-session-additional-dialog-status span').text(response);
                        }
                        if (response.hasOwnProperty('status_code')) {
                            $('#use-case-edit-session-additional-dialog-status span').text(response.status_code);
                        }

                        if (response.hasOwnProperty('new_location_url')) {
                            window.location.href = response.new_location_url;
                        }
                    });
                });

                return link;
            },
            /**
             * generates the html template
             *
             * @returns {jQuery|HTMLElement}
             */
            generateTemplate : function () {
                var template = $('<div />');
                template.append('<p>Content editing is blocked due to this page is a reference of use case #' + this.useCaseId + ' and content is not direct part of this.</p>')
                template.append(this.createLink('Import use case pages', 'include'));
                template.append('<br/><br/>');
                template.append(this.createLink('Remove use case pages', 'delete'));
                template.append('<br/><br/>');
                template.append('<div id="use-case-edit-session-additional-dialog-status">Status: <span></span></div>');

                return template;
            }
            }
    }

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/use-case/edit-session/additional-dialog.js
 ** module id = 1142
 ** module chunks = 0
 **/